import { OdinIcon, OdinIconSize, Popover, PopoverContent, PopoverTrigger } from '@myosh/odin-components';
import clsx from 'clsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { odinIconStyle } from '../../constants/common-style-constants';
import { AboutMenuOption } from './about-menu-component';

export const TopMenuComponent = () => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [aboutModalVisible, setAboutModalVisible] = useState(false);
  const { t } = useTranslation();

  const handleAboutClick = () => {
    setAboutModalVisible(true);
    setIsPopoverOpen(false);
  };

  return (
    <>
      <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen} modal={false}>
        <PopoverTrigger
          className={clsx('p-1', isPopoverOpen ? 'rounded-md ring-2 ring-primary-2' : 'flex flex-row justify-between')}
        >
          <OdinIcon icon="Menu" size={OdinIconSize.Small} className={odinIconStyle} data-testid="top-menu-icon" />
        </PopoverTrigger>
        <PopoverContent align="end" className="w-32">
          <ul className="flex flex-col flex-wrap">
            <li
              className="text-sm flex items-center gap-2 whitespace-nowrap leading-5 cursor-pointer hover:bg-primary-4"
              onClick={handleAboutClick}
            >
              <OdinIcon icon="Info" size={OdinIconSize.ExtraSmall} />
              {t('about')}
            </li>
          </ul>
        </PopoverContent>
      </Popover>
      <AboutMenuOption showAboutInfo={aboutModalVisible} setShowAboutInfo={setAboutModalVisible} />
    </>
  );
};
